


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import FrequencyQuestTable from './components/FrequencyQuestTable.vue';
import QuestExpHookManager from './components/QuestExpHookManager.vue'

@Component({
    components: {
        FrequencyQuestTable,
        QuestExpHookManager
    }
})
export default class QuestManager extends Vue {
    tab = null;

    successMessage = false;
    error = {
        show: false,
        message: ''
    };

    public onError(err: any) {
        this.error.show = true;
        this.error.message = err.message;
    }
}
